import React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { Field } from "react-final-form";
import { connect } from "react-redux";

function PortList(props) {
  return (
    <Field name={"port"}>
      {({ input }) => (
        <Autocomplete
          disablePortal
          style={{ width: "100%" }}
          id="combo-box-ports"
          required={true}
          name="port"
          label="Port"
          options={props.portList.data}
          sx={{ width: 300 }}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          onChange={(event, option) => input.onChange(option)}
          renderInput={(params) => (
            <TextField {...params} {...input} label="Port" />
          )}
        />
      )}
    </Field>
  );
}
const mapStatToProps = (state) => {
  return { ...state, port: state.PortsReducer };
};
export default connect(mapStatToProps, null)(PortList);
